import { useEffect } from "react";

/**
 * PageMeta — lightweight per-page SEO helper.
 * Sets document.title and meta description without a heavy library.
 */
export default function PageMeta({ title, description }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
    window.scrollTo(0, 0);
  }, [title, description]);
  return null;
}
